import { pgTable, boolean, timestamp, integer, index, foreignKey, check, pgEnum } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { accessTargetType, courseType } from './enums';
import { pricingTier } from './pricing-tier';

export const entitlementSelectionMode = pgEnum('EntitlementSelectionMode', ['specific', 'quantity']);

export const pricingTierEntitlement = pgTable('PricingTierEntitlement', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),

  pricingTierId: integer().notNull(),

  targetType: accessTargetType().notNull(),
  targetId: integer(),

  selectionMode: entitlementSelectionMode().notNull(),
  quantity: integer(),

  filterCourseType: courseType(),

  accessDurationDays: integer(),

  isActive: boolean().default(true).notNull(),
  order: integer().default(0).notNull(),

  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).$onUpdate(() => new Date()).notNull(),
}, (table) => [
  check('pricing_tier_entitlement_mode_check',
    sql`(${table.selectionMode} = 'specific' AND ${table.targetId} IS NOT NULL AND ${table.quantity} IS NULL)
     OR (${table.selectionMode} = 'quantity' AND ${table.targetId} IS NULL AND ${table.quantity} IS NOT NULL AND ${table.quantity} > 0)`
  ),
  check('pricing_tier_entitlement_filter_check',
    sql`${table.filterCourseType} IS NULL OR (${table.targetType} = 'COURSE' AND ${table.selectionMode} = 'quantity')`
  ),
  check('pricing_tier_entitlement_target_type_check',
    sql`${table.targetType} IN ('COURSE', 'CHANNEL', 'BOOK')`
  ),
  index('PricingTierEntitlement_tierId_idx').using('btree', table.pricingTierId.asc().nullsLast()),
  index('PricingTierEntitlement_targetType_idx').using('btree', table.targetType.asc().nullsLast()),
  foreignKey({
    columns: [table.pricingTierId],
    foreignColumns: [pricingTier.id],
    name: 'PricingTierEntitlement_pricingTierId_fkey',
  }).onUpdate('cascade').onDelete('cascade'),
]);
